import React from 'react';
import StatusCode from '../../util/StatusCode';
import * as Helper from '../../util/Helper';
import TableHorizontal, { InfoObject } from './TableHorizontal';
import { CoreObjectLogs } from '../../models/CoreObjectLogs';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RequestState } from '../../models/RequestState';


interface ObjectLogsProps {
    objectLogs: RequestState<CoreObjectLogs[]>
    noResMsg: string
}

const ObjectLogs: React.FC<ObjectLogsProps> = (props: ObjectLogsProps) => {
    const { t } = useTranslation('schoolAdministration');

    let formattedObjectLogs: InfoObject[] = [];
    if (props.objectLogs.code === StatusCode.COMPLETE) {
        formattedObjectLogs = props.objectLogs.data.map((o, i) => ({
            id: `${i}`,
            data: [
                { value: <Link to={`/module/${o.module.id}/status`}>{o.module.title}</Link> },
                { value: Helper.formatDate(o.timestamp) },
                { value: t('severityLevels.' + o.severity, { ns: 'schoolAdministration' }) },
                { value: o.message },
                { value: o.eventId },
            ]
        })) ?? [];
    }

    return (<div>
        <h5 className="header-menu">{t('objectLogsModule.logInformation', { ns: 'schoolAdministration' })}</h5>
        <TableHorizontal
            header={[{ value: t('objectLogsModule.tableHeaders.module', { ns: 'schoolAdministration' }) }, { value: t('objectLogsModule.tableHeaders.timeStamp', { ns: 'schoolAdministration' }) }, { value: t('objectLogsModule.tableHeaders.severity', { ns: 'schoolAdministration' }) }, { value: t('objectLogsModule.tableHeaders.message', { ns: 'schoolAdministration' }) }, { value: t('objectLogsModule.tableHeaders.eventId', { ns: 'schoolAdministration' }) }]}
            info={formattedObjectLogs ?? []}
            error={props.objectLogs.code === StatusCode.ERROR}
            searching={props.objectLogs.code === StatusCode.PENDING}
            noResMsg={props.noResMsg}
        />
    </div>);
}

export default ObjectLogs;
